<template>
  <form
    class="flex w-full flex-col items-center"
    @submit="handleSubmit">
    <div class="class relative z-20 mt-6 grid w-full gap-x-4 gap-y-2 md:grid-cols-2">
      <label class="text-sm md:order-1"> {{ areaLabel }}</label>

      <Dropdown
        :items="AREAS"
        :model-value="refine.area"
        :placeholder="defaultArea.label"
        class="md:order-3"
        @update:model-value="setSelected($event, JobFilterId.AREA)" />

      <label class="mt-2 text-sm md:order-2 lg:mt-0"> {{ locationLabel }}</label>

      <Dropdown
        :items="LOCATIONS"
        :model-value="refine.location"
        :placeholder="defaultLocation.label"
        class="md:order-4"
        @update:model-value="setSelected($event, JobFilterId.LOCATION)" />
    </div>

    <label class="mr-auto mt-4 text-sm"> {{ inputLabel }}</label>
    <SectionNewsletterFormInput
      v-model="inputEmail"
      :state="state"
      :label="inputLabel"
      :placeholder="inputPlaceholder"
      class="mt-2 w-full sm:w-full md:w-full"
      type="small">
      <SectionNewsletterFormButton
        :state="state"
        :label="submitLabel"
        type="small" />
    </SectionNewsletterFormInput>

    <SectionNewsletterFormCheckbox
      :state="state"
      :copy="consentLabel"
      class="mt-6" />

    <SectionNewsletterFormToast
      :state="state"
      :success-message="successMessage"
      :error-message="errorMessage" />
  </form>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  import { AREAS, JobFilterId, LOCATIONS } from '~/constants/jobs'

  import useNewsletter from '../../../composables/use-newsletter'
  import type { ComboboxItem } from '../../../models/combobox'

  type FormToastProps = {
    areaLabel: string
    locationLabel: string
    inputPlaceholder: string
    inputLabel: string
    submitLabel: string
    consentLabel: string
    successMessage: string
    errorMessage: string
  }

  defineProps<FormToastProps>()

  const defaultArea = AREAS[0]
  const defaultLocation = LOCATIONS[0]

  const refine = ref<{ area: ComboboxItem; location: ComboboxItem }>({
    area: defaultArea,
    location: defaultLocation
  })

  const setSelected = (item: ComboboxItem | ComboboxItem[], id: JobFilterId.AREA | JobFilterId.LOCATION) => {
    if (Array.isArray(item)) {
      return
    }
    refine.value[id] = item
  }

  const { subscribe, state } = useNewsletter()

  const inputEmail = ref('')

  function handleSubmit(e: Event) {
    e.preventDefault()

    subscribe(inputEmail.value, 164, refine.value.location.label, refine.value.area.label)
      .then(() => {
        inputEmail.value = ''
      })
      .catch(() => {
        console.error('Subscribe failed')
      })
  }
</script>
